import React, { useEffect, useCallback, useRef, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as UiActions from 'actions/UiActions';
import { isTerminal } from 'utils/UiHelper';
import {
    SearchInputContainer,
    ViewSearchBoxCancelButton,
    ViewSearchForm,
} from './styled';
import { detectMobile } from '../../utils/UiHelper';
import SearchIcon from 'images/icons/search.svg';

const ViewSearchBoxNew = ({
    autofocus = false,
    value: initialValue = '',
    onSearchTextHandler = () => {},
    uiActions,
}) => {
    const inputRef = useRef(null);
    const [value, setValue] = useState(initialValue || '');

    const formSubmitHandler = (event) => {
        event.preventDefault();
    };

    const handleClickOutside = useCallback(
        (event) => {
            if (
                value &&
                event?.target?.id !== 'search-input' &&
                event?.target?.className?.indexOf &&
                event?.target?.className.indexOf('back-btn') < 0 &&
                event?.target?.className.indexOf('fa-angle-left') < 0
            ) {
                setTimeout(() => {
                    if (window.location?.pathname.indexOf('/kamp') < 0) {
                        onClickClearBtn();
                    }
                }, 300);
            }
        },
        [value]
    );

    const validateSearchInput = (searchText) => {
        if (!searchText) return '';

        const trimmedText = searchText.trim();

        if (trimmedText.length === 0) return '';

        return trimmedText;
    };

    const onChangeValue = useCallback(
        (_, newValue) => {
            setValue(newValue);
        },
        [onSearchTextHandler]
    );

    const onChangeVal = (event) => {
        const { value: newValue } = event.target;
        setValue(newValue);
    };

    const onClickClearBtn = () => {
        setValue('');
        onSearchTextHandler('');
    };

    const onFocusHandler = (valueHandler, event) => {
        uiActions.setKeyboardPopupStatus({
            element: event.target,
            valueHandler,
        });
    };

    useEffect(
        () => {
            if (!isTerminal() && autofocus && initialValue?.length > 0) {
                inputRef.current?.focus();
            }

            if (!initialValue) {
                setValue('');
            }
        },
        [autofocus, initialValue]
    );

    // useEffect(
    //     () => {
    //             document.addEventListener('mousedown', handleClickOutside);
    //
    //             return () => {
    //                 document.removeEventListener(
    //                     'mousedown',
    //                     handleClickOutside
    //                 );
    //             };
    //     },
    //     [initialValue, handleClickOutside]
    // );

    const terminalProps = isTerminal()
        ? {
              onFocus: (e) => onFocusHandler(onChangeValue, e),
              onChange: (e) => onChangeValue(null, e.target.value),
          }
        : {};

    useEffect(
        () => {
            const validatedSearch = validateSearchInput(value);

            if (validatedSearch) {
                onSearchTextHandler(validatedSearch);
            } else {
                onSearchTextHandler('');
            }
        },
        [value]
    );

    return (
        <SearchInputContainer>
            <ViewSearchForm
                onSubmit={formSubmitHandler}
                isMobile={detectMobile()}
            >
                <input
                    id="search-input"
                    autoComplete="off"
                    name="search"
                    type="text"
                    placeholder="Søg efter kampe..."
                    ref={inputRef}
                    onChange={onChangeVal}
                    value={value}
                    {...terminalProps}
                />
                <img src={SearchIcon} alt="Search" />
                {value && (
                    <ViewSearchBoxCancelButton onClick={onClickClearBtn}>
                        <i className="fa fa-times" aria-hidden="true" />
                    </ViewSearchBoxCancelButton>
                )}
            </ViewSearchForm>
        </SearchInputContainer>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        uiActions: bindActionCreators(UiActions, dispatch),
    };
};

export default connect(
    null,
    mapDispatchToProps
)(ViewSearchBoxNew);
